import Api from "@/api";
const route = "auth";

const preRegister = async body => {
  const result = await Api.post(`v1/${route}/pre-register`, body);
  return result;
};

const me = async query => {
  const result = await Api.query(`v1/${route}/me`, query);
  return result.data;
};

const login = async body => {
  const result = await Api.post(`v1/${route}/login`, body);
  return result.data;
};

const passwordReset = async body => {
  const result = await Api.post(`v1/${route}/password-reset`, body);
  return result.data;
};

const passwordRecovery = async body => {
  const result = await Api.post(`v1/${route}/password-recovery`, body);
  return result.data;
};

const logout = async () => {
  const result = await Api.post(`v1/${route}/logout`);
  return result.data;
};

const meInGfs = async query => {
  const result = await Api.query(`v1/gfs/${route}/me`, query);
  return result.data;
};

const preRegisterFinished = async body => {
  const result = await Api.post(`v1/${route}/pre-register-finished`, body);
  return result.data;
};

const getFeatures = async () => {
  const result = await Api.query(`v1/${route}/features`);
  return result.data;
};

const getActions = async () => {
  const result = await Api.query(`v1/${route}/actions`);
  return result.data;
};

const getNotifications = async () => {
  const result = await Api.query(`v1/${route}/notifications`);
  return result.data;
};

export default {
  preRegister,
  me,
  meInGfs,
  preRegisterFinished,
  login,
  passwordReset,
  passwordRecovery,
  logout,
  getFeatures,
  getActions,
  getNotifications
};
